var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstantNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "#0260FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0454 25.4419H41.5911V42.496H40.0454V25.4419Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4092 25.4419H19.9545V42.496H18.4092V25.4419Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3681 43.2725H16.6318C14.626 43.2725 13 41.6465 13 39.6408V20.6318C13 18.626 14.626 17 16.6318 17H43.3681C45.3739 17 46.9999 18.626 46.9999 20.6318V39.6408C46.9999 41.6465 45.3739 43.2725 43.3681 43.2725ZM16.6318 18.5454C15.4795 18.5454 14.5454 19.4795 14.5454 20.6318V39.6408C14.5454 40.7931 15.4795 41.7272 16.6318 41.7272H43.3681C44.5204 41.7272 45.4545 40.7931 45.4545 39.6408V20.6318C45.4545 19.4795 44.5204 18.5454 43.3681 18.5454H16.6318Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 36.1055L13.2609 21.2113L14.2847 20.0522L30 34.0386L45.7154 20.0522L46.7392 21.2113L30 36.1055Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 29.1508L17.7136 18.352L18.7278 17.1929L30.0001 27.0935L41.2625 17.1929L42.2863 18.352L30.0001 29.1508Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantNotifications);
export default __webpack_public_path__ + "static/media/instant-notifications.9a797c5d1496fbde447e6fc6bbd553e9.svg";
export { ForwardRef as ReactComponent };